export enum UnitConvertStrategy {
  RoundNormal,
  RoundDown,
  RoundUp,
}
